module.exports = __webpack_public_path__ + "static/media/15UN-Habitat4.6c812df6.jpg";